import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ArchiveItem from "./archive/ArchiveItem";
import {TailSpin} from "react-loading-icons";
import {setStructuredArchiveData} from "./schema";

const Archive = ({ client }) => {
	const [apartments, setApartments] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const fireQuery = async () => {
		try {
			return await axios({
				url: client,
				method: 'POST',
				data: {
					query: `
                        query apartmentsQuery($date: String!) {
                            apartments(
                                where: {metaQuery: {relation: AND, metaArray: [{key: "registration_open", value: "1", compare: EQUAL_TO}, {key: "registration_ends", value: $date, compare: GREATER_THAN}]}}
                            ) {
                                nodes {
                                    id
                                    apartmentId
                                    title
                                    meta {
                                        address
                                        apartmentType
                                        availabilityDate
                                        availableByAgreement
                                        cats
                                        city
                                        flatFit
                                        flatHighlights
                                        floor
                                        minResidents
                                        numberOfRooms
                                        objectId
                                        registrationEnds
                                        registrationOpen
                                        rentPerMonth
                                        settlement
                                        settlementLink
                                        surfaceArea
                                        zip
                                        thumbnailId {
                                            node {
                                                title
                                                mediaItemUrl
                                            }
                                        }
                                        headerImage {
                                            node {
                                                title
                                                mediaItemUrl
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `,
					variables: {
						// registration_ends ist im Backend in UTC gespeichert
						date: new Date().toISOString().slice(0, 19).replace('T', ' '),
					}
				}
			});
		} catch (error) {
			console.error("Error fetching data: ", error);
		}
	};

	useEffect(() => {
		fireQuery().then((result) => {
			setApartments(result.data.data.apartments.nodes);
			setStructuredArchiveData(result.data.data.apartments.nodes);
			setIsLoading(false);
		});
	}, [client]);

	if(isLoading) {
		return (
			<section>
				<TailSpin stroke="#009cdd" fill="#009cdd" height="2rem" style={{"display": "block", "margin": "auto"}} />
				<div style={{"display": "block", "textAlign": "center", "marginTop": "8px"}}>
					<p>Lade…</p>
				</div>
			</section>
		)
	} else {
		return (
			<div className="row">
				{apartments.length > 0 ? (
					apartments.map(apartment => (
						<ArchiveItem key={apartment.id} apartment={apartment} />
					))
				) : (
					<div className={"col"}>
						<h4>Aktuell sind keine Wohnungen zu besichtigen.</h4>
					</div>
				)}
			</div>
		);
	}
};

export default Archive;
